import useEntity from "../../hooks/useLogHistory";
import LogHistoryDetail from "../../components/logHistory/LogHistoryDetail/LogHistoryDetail";
import LogHistoryScoped from "../../components/logHistory/LogHistoryDetail/LogHistoryScoped";
import LogHistoryTabs from "../../components/logHistory/LogHistoryDetail/LogHistoryTabs";
import { useGetLogHistoryQuery } from "../../apis/LogHistory.api";
import { PrimaryLogHistory } from "../../types/models/LogHistory";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const LogHistoryDetailPage = () => {

    useTitle(t`Details Log History`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { logHistoryId: id } = useParams();

    const { data, refetch } = useGetLogHistoryQuery(PrimaryLogHistory.fromPath(id))
    const { deleteLogHistory } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteLogHistory(data, '..')
    }, [data, deleteLogHistory])

    if (id === 'scoped') {
        return (<LogHistoryScoped/>)
    }

    return (
        <Box data-testid="LogHistory-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <LogHistoryDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/LogHistories/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="LogHistory-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <LogHistoryTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default LogHistoryDetailPage;
